import { observer } from "mobx-react-lite"
import { FC } from "react"
import { useLocation } from "react-router-dom"
import useWindowDimensions from "../../../core/hooks/useWindowDimensions"

import styles from "./HomeCardWrap.module.scss"

export interface HomeCardWrapProps {
  minHeight?: string
  children: any
}

const HomeCardWrap: FC<HomeCardWrapProps> = ({
  children, minHeight
}) => {

  const { width } = useWindowDimensions()
  const location = useLocation()

  return (
    <>
      <div className={styles.card_wrap} id="HomeCardWrap" style={{ minHeight: minHeight }}>
        {children}
      </div>
    </>
  )
}

export default observer(HomeCardWrap)